import React from 'react'

export const Contacto = () => {
  return (
    <div>
          <main className="layout__content">
            <section className="content__page content__contact">
                {/* <!-- este el contenido que cambia --> */}
                <header className="contact__header">
                    <h2 className="contact__title">Contacto</h2>
                </header>

                <div className="contact__container">
                    <section className="contact__info">
                        <div className="contact__data">
                            <i className="contact__icon fa-solid fa-location-dot"></i>
                            <h2 className="contact__subtitle">México</h2>
                        </div>
                        <div className="contact__data">
                            <i className="contact__icon fa-solid fa-phone"></i>
                            <h2 className="contact__subtitle">+52 55 5252 6510</h2>
                        </div>
                        <div className="contact__data">
                            <i className="contact__icon fa-solid fa-envelope"></i>
                            <h2 className="contact__subtitle">enrique_d69@hotmail.com</h2>
                        </div>
                        <div className="contact__data">
                            <i className="contact__icon fa-solid fa-circle-check"></i>
                            <h2 className="contact__subtitle">Desarrollador Freelance</h2>
                        </div>
                    </section>

                    <section className="contact__form-box">
                        <header className="contact__form-header">
                            <h3 className="form-header__title">¿Como puedo <span className="title__color">Ayudarte?</span></h3>
                        </header>
                        <form className="contact__form">
                            <div className="form__container">

                                <section className="form__left">
                                    <div className="form__group">
                                        <input type="text" className="form__input" name="name" required
                                            placeholder="Nombre" />
                                        <label for="name" className="form__label">Nombre</label>
                                    </div>
                                    <div className="form__group">
                                        <input type="email" className="form__input" name="email" required
                                            placeholder="Email" />
                                        <label for="email" className="form__label">Email</label>
                                    </div>
                                    <div className="form__group">
                                        <input type="text" className="form__input" name="subject" required
                                            placeholder="Subject" />
                                        <label for="subject" className="form__label">Asunto</label>
                                    </div>
                                </section>

                                <section className="form__rigth">
                                    <div className="form__group form__group--textarea">
                                        <textarea className="form__input form__input--textarea" name="message" required
                                            placeholder="message"></textarea>
                                        <label for="message" className="form__label">Mensaje</label>
                                    </div>
                                </section>

                            </div>
                            <input type="submit" className="form__button" value="Enviar mensaje"></input>

                        </form>
                        
                    </section>
                    <div className="contact__map" id="load-iframe-map">
                            <span className="loader"></span>
                    </div>
                </div>
            </section>

        </main>
    </div>
  )
}
